import { atom } from "recoil"

export const AtomDescription = atom({
    key:'ATOMDESCRIPTION',
    default:''
})
  